import { createApp } from 'vue'
import router from './router'
import i18n from './i18n'
import './style.css'
import RootLayout from './RootLayout.vue'

const app = createApp(RootLayout)

app.use(router)
app.use(i18n)

app.mount('#app')

// Set document title from environment variable
document.title = import.meta.env.VITE_APP_NAME || 'Cloudinary Image Viewer'
